//============ ps.core.services.cms.ArticleQueryPara =============
/* eslint-disable camelcase */
import {
  QueryParameter
} from '@/base/QueryParameter';

export class ArticleQueryPara extends QueryParameter {
  constructor() {
    super();
  }

  _QueryAttr_KeyId = 'keyId';
  _QueryAttr_MianTitle = 'mianTitle';
  _QueryAttr_Author = 'author';
  _QueryAttr_Tags = 'tags';
  _QueryAttr_Content = 'cms';
  _QueryAttr_CategoryCode = 'categoryCode';
  _QueryAttr_Source = 'source';
  _QueryAttr_PubTime = 'pubTime';
  _QueryAttr_PubName = 'pubName';
  _QueryAttr_EndTime = 'endTime';
  _QueryAttr_CheckNum = 'checkNum';
  _QueryAttr_Status = 'status';
  _QueryAttr_PubStatus = 'pubStatus';
  _QueryAttr_SortNum = 'sortNum';
  _QueryAttr_ShareStatus = 'shareStatus';
  _QueryAttr_IsTop = 'isTop';
  _QueryAttr_IsDelete = 'isDelete';
  _QueryAttr_CommentStatus = 'commentStatus';
  _OrderAttr_KeyId = 'keyId';
  _OrderAttr_Author = 'author';
  _OrderAttr_Tags = 'tags';
  _OrderAttr_CategoryCode = 'categoryCode';
  _OrderAttr_Source = 'source';
  _OrderAttr_PubTime = 'pubTime';
  _OrderAttr_PubName = 'pubName';
  _OrderAttr_EndTime = 'endTime';
  _OrderAttr_CheckNum = 'checkNum';
  _OrderAttr_Status = 'status';
  _OrderAttr_PubStatus = 'pubStatus';
  _OrderAttr_SortNum = 'sortNum';
  _OrderAttr_ShareStatus = 'shareStatus';
  _OrderAttr_IsTop = 'isTop';
  _OrderAttr_IsDelete = 'isDelete';
  _OrderAttr_CommentStatus = 'commentStatus';


  /*keyId:String*/
  setParamByKeyId(keyId) {
    this.addParameter(this._QueryAttr_KeyId, keyId);
  }

  /*isDelete:boolean*/
  setParamByIsDelete(isDelete) {
    this.addParameter(this._QueryAttr_IsDelete, isDelete);
  }

  /*categoryCode:String*/
  setParamByCategoryCode(categoryCode) {
    this.addParameter(this._QueryAttr_CategoryCode, categoryCode);
  }

  /*status:int*/
  setParamByStatus(status) {
    this.addParameter(this._QueryAttr_Status, status);
  }

  /*source:String*/
  setParamBySource(source) {
    this.addParameter(this._QueryAttr_Source, source);
  }

  /*statuss:int[]*/
  setParamByStatus_Enum(statuss) {
    this.addParameterByEnum(this._QueryAttr_Status, statuss);
  }

  /*keyIds:String[]*/
  setParamByKeyId_Enum(keyIds) {
    this.addParameterByEnum(this._QueryAttr_KeyId, keyIds);
  }

  /*mianTitle:String*/
  setParamByMianTitle(mianTitle) {
    this.addParameter(this._QueryAttr_MianTitle, mianTitle);
  }

  /*mianTitles:String[]*/
  setParamByMianTitle_Enum(mianTitles) {
    this.addParameterByEnum(this._QueryAttr_MianTitle, mianTitles);
  }

  /*authors:String[]*/
  setParamByAuthor_Enum(authors) {
    this.addParameterByEnum(this._QueryAttr_Author, authors);
  }

  /*tagss:String[]*/
  setParamByTags_Enum(tagss) {
    this.addParameterByEnum(this._QueryAttr_Tags, tagss);
  }

  /*content:String*/
  setParamByContent(content) {
    this.addParameter(this._QueryAttr_Content, content);
  }

  /*contents:String[]*/
  setParamByContent_Enum(contents) {
    this.addParameterByEnum(this._QueryAttr_Content, contents);
  }

  /*categoryCodes:String[]*/
  setParamByCategoryCode_Enum(categoryCodes) {
    this.addParameterByEnum(this._QueryAttr_CategoryCode, categoryCodes);
  }

  /*sources:String[]*/
  setParamBySource_Enum(sources) {
    this.addParameterByEnum(this._QueryAttr_Source, sources);
  }

  /*pubTime:Date*/
  setParamByPubTime(pubTime) {
    this.addParameter(this._QueryAttr_PubTime, pubTime);
  }

  /*startDate:Date, endDate:Date*/
  setParamByPubTime_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_PubTime, startDate, endDate);
  }

  /*pubName:String*/
  setParamByPubName(pubName) {
    this.addParameter(this._QueryAttr_PubName, pubName);
  }

  /*pubNames:String[]*/
  setParamByPubName_Enum(pubNames) {
    this.addParameterByEnum(this._QueryAttr_PubName, pubNames);
  }

  /*endTime:Date*/
  setParamByEndTime(endTime) {
    this.addParameter(this._QueryAttr_EndTime, endTime);
  }

  /*startDate:Date, endDate:Date*/
  setParamByEndTime_Range(startDate, endDate) {
    this.addDateParameterByRange(this._QueryAttr_EndTime, startDate, endDate);
  }

  /*checkNum:int*/
  setParamByCheckNum(checkNum) {
    this.addParameter(this._QueryAttr_CheckNum, checkNum);
  }

  /*checkNum:int*/
  setParamByCheckNumIncZero(checkNum) {
    this.addParameterIncZero(this._QueryAttr_CheckNum, checkNum);
  }

  /*low:int, high:int*/
  setParamByCheckNum_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_CheckNum, low, high);
  }

  /*checkNums:int[]*/
  setParamByCheckNum_Enum(checkNums) {
    this.addParameterByEnum(this._QueryAttr_CheckNum, checkNums);
  }

  /*status:int*/
  setParamByStatusIncZero(status) {
    this.addParameterIncZero(this._QueryAttr_Status, status);
  }

  /*low:int, high:int*/
  setParamByStatus_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_Status, low, high);
  }

  /*pubStatus:int*/
  setParamByPubStatus(pubStatus) {
    this.addParameter(this._QueryAttr_PubStatus, pubStatus);
  }

  /*pubStatus:int*/
  setParamByPubStatusIncZero(pubStatus) {
    this.addParameterIncZero(this._QueryAttr_PubStatus, pubStatus);
  }

  /*low:int, high:int*/
  setParamByPubStatus_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_PubStatus, low, high);
  }

  /*pubStatuss:int[]*/
  setParamByPubStatus_Enum(pubStatuss) {
    this.addParameterByEnum(this._QueryAttr_PubStatus, pubStatuss);
  }

  /*sortNum:int*/
  setParamBySortNum(sortNum) {
    this.addParameter(this._QueryAttr_SortNum, sortNum);
  }

  /*sortNum:int*/
  setParamBySortNumIncZero(sortNum) {
    this.addParameterIncZero(this._QueryAttr_SortNum, sortNum);
  }

  /*low:int, high:int*/
  setParamBySortNum_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_SortNum, low, high);
  }

  /*sortNums:int[]*/
  setParamBySortNum_Enum(sortNums) {
    this.addParameterByEnum(this._QueryAttr_SortNum, sortNums);
  }

  /*shareStatus:int*/
  setParamByShareStatus(shareStatus) {
    this.addParameter(this._QueryAttr_ShareStatus, shareStatus);
  }

  /*shareStatus:int*/
  setParamByShareStatusIncZero(shareStatus) {
    this.addParameterIncZero(this._QueryAttr_ShareStatus, shareStatus);
  }

  /*low:int, high:int*/
  setParamByShareStatus_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_ShareStatus, low, high);
  }

  /*shareStatuss:int[]*/
  setParamByShareStatus_Enum(shareStatuss) {
    this.addParameterByEnum(this._QueryAttr_ShareStatus, shareStatuss);
  }

  /*commentStatus:int*/
  setParamByCommentStatus(commentStatus) {
    this.addParameter(this._QueryAttr_CommentStatus, commentStatus);
  }

  /*commentStatus:int*/
  setParamByCommentStatusIncZero(commentStatus) {
    this.addParameterIncZero(this._QueryAttr_CommentStatus, commentStatus);
  }

  /*low:int, high:int*/
  setParamByCommentStatus_Range(low, high) {
    this.addNumberParameterByRange(this._QueryAttr_CommentStatus, low, high);
  }

  /*commentStatuss:int[]*/
  setParamByCommentStatus_Enum(commentStatuss) {
    this.addParameterByEnum(this._QueryAttr_CommentStatus, commentStatuss);
  }

  /*author:String*/
  setParamByAuthor(author) {
    this.addParameter(this._QueryAttr_Author, author);
  }

  /*tags:String*/
  setParamByTags(tags) {
    this.addParameter(this._QueryAttr_Tags, tags);
  }

  /*isTop:boolean*/
  setParamByIsTop(isTop) {
    this.addParameter(this._QueryAttr_IsTop, isTop);
  }

}